import { useMemo } from "react";

import { locationOptions } from "../utils/usRegions";

const useLocationInputs = (
  idPrefix: string = "location",
  parentResource?: string,
  namePrefix?: string,
  labelPrefix?: string
) => {
  const labelPrefixStr = labelPrefix ? `${labelPrefix} ` : "";

  const getInputName = (name: string) =>
    `${parentResource ? `${parentResource}.` : ""}${
      namePrefix ? `${namePrefix}_` : ""
    }${name}`;

  return useMemo(
    () => ({
      //Alternative to 'street' and 'street2', used in for insurance fields
      address: {
        id: `${idPrefix}__address`,
        name: getInputName("address"),
        label: `${labelPrefixStr}Street Address`,
      },
      address2: {
        id: `${idPrefix}__address2`,
        name: getInputName("address2"),
        label: `${labelPrefixStr}Street Address Contd.`,
      },

      // Normal Location street fields
      street: {
        id: `${idPrefix}__street`,
        name: getInputName("street"),
        label: `${labelPrefixStr}Street Address`,
      },
      street2: {
        id: `${idPrefix}__street2`,
        name: getInputName("street2"),
        label: `${labelPrefixStr}Street Address Contd.`,
      },
      city: {
        id: `${idPrefix}__city`,
        name: getInputName("city"),
        label: `${labelPrefixStr}City`,
      },
      state: {
        id: `${idPrefix}__state`,
        name: getInputName("state"),
        label: `${labelPrefixStr}State`,
        type: "select",
        defaultOptionLabel: "Select...",
        options: locationOptions,
      },
      zipcode: {
        id: `${idPrefix}__zipcode`,
        name: getInputName("zipcode"),
        label: `${labelPrefixStr}Zipcode`,
        minLength: 5,
      },
      phone1: {
        id: `${idPrefix}__phone1`,
        name: getInputName("phone1"),
        label: `${labelPrefixStr}Phone 1`,
        minLength: 12,
      },
      phone2: {
        id: `${idPrefix}__phone2`,
        name: getInputName("phone2"),
        label: `${labelPrefixStr}Phone 2`,
        minLength: 12,
      },
    }),
    [parentResource, idPrefix, labelPrefix]
  );
};

export default useLocationInputs;
